import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [needsVerify, setNeedsVerify] = useState(false);
  const [resending, setResending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/home');
    } catch (err) {
      if (err.response?.data?.code === 'EMAIL_NOT_VERIFIED') {
        setNeedsVerify(true);
        toast.error(err.response.data.message);
      } else {
        setNeedsVerify(false);
        toast.error(err.response?.data?.message || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      const api = (await import('../utils/api')).default;
      const { data } = await api.post('/auth/resend-verification', { email: form.email });
      toast.success(data.message || 'Sent');
    } catch {
      toast.error('Could not send. Please try again shortly.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="cr-login-wrap">
    <style>{`
      .cr-login-wrap{min-height:100vh;background:var(--cr-primary);display:flex;flex-direction:column}
      .cr-login-hero{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 24px 20px}
      .cr-login-sheet{background:#fff;border-radius:24px 24px 0 0;padding:28px 24px 40px}
      @media (min-width:768px){
        .cr-login-wrap{justify-content:center;padding:40px 20px}
        .cr-login-hero{flex:0 0 auto;padding:0 0 28px}
        .cr-login-sheet{border-radius:18px;max-width:420px;width:100%;margin:0 auto;padding:32px 32px 36px;box-shadow:0 18px 40px rgba(0,0,0,.28)}
      }
    `}</style>

      <div className="cr-login-hero">
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src="/cr-logo.png" alt="Connected Rider" style={{ width: '150px', maxWidth: '70vw', height: 'auto', display: 'block', margin: '0 auto 6px' }} />
          <h1 style={{ color: 'white', fontSize: '26px', fontWeight: '700' }}>Connected Rider</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px', marginTop: '4px' }}>Horse care, community & marketplace</p>
        </div>
      </div>

      <div className="cr-login-sheet">
        <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>Welcome back</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" placeholder="your@email.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-input" type="password" placeholder="Your password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          </div>
          <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading} style={{ marginTop: '8px' }}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        {needsVerify && (
          <div style={{ marginTop: 16, padding: '12px 14px', borderRadius: 10, background: 'var(--cr-primary-light)', border: '1px solid var(--cr-primary)' }}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Confirm your email first</div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 10 }}>
              We sent a link when you signed up. Check your inbox and spam folder, or send another.
            </div>
            <button className="btn btn-secondary btn-sm" onClick={handleResend} disabled={resending}>
              {resending ? 'Sending...' : 'Send another link'}
            </button>
          </div>
        )}
        <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '14px' }}>
          <Link to="/forgot-password" style={{ color: 'var(--cr-primary)', fontWeight: '500', textDecoration: 'none' }}>Forgot your password?</Link>
        </p>
        <p style={{ textAlign: 'center', marginTop: '8px', fontSize: '14px' }}>
          Don't have an account?{' '}
          <Link to="/register" style={{ color: 'var(--cr-primary)', fontWeight: '500', textDecoration: 'none' }}>Create one</Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
